import React, { useEffect } from "react";
import AppLayout from "../components/app-layoout";
import { LayoutContainer } from "../components/app-layoout/container";
import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import Iconify from "../components/iconify/iconify";
import { useParams } from "react-router-dom";
import UploadHauseCarousel from "../components/PropertiesView/Hause-carousel/UploadHauseCarousel";
import { v4 as uuidv4 } from "uuid";
import { usePropertiesSlug } from "../hooks/use-data-properties";
import { PropertyDescriptionEdit } from "../components/PropertyEdit/PropertyDescriptionEdit";
import { PropertyDescriptionListEdit } from "../components/PropertyEdit/PropertyDescriptionListEdit";
import ModelsCarouselEdit from "../components/PropertyEdit/ModelsCarouselEdit";
import { patch } from "../components/utils/request";
import { useAuthStore } from "../stores/authStore";
import { PropertyLocalEdit } from "../components/PropertyEdit/PropertyLocalEdit";
import { SlackChat } from "../components/Yoopta/YooptaEdit";

const StyledLocationBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  color: theme.palette.text.secondary,
}));

const PropertiesViewEdit = () => {
  let { slug } = useParams();

  const { auth } = useAuthStore();
  const { dataPropertiesSlugQuery } = usePropertiesSlug(slug);

  const uploadCarousel = async (items) => {
    const data = [];
    const formData = new FormData();
    // Example of processing both server and new images
    items.forEach((item, i) => {
      if (item.url.includes("blob") && item.file) {
        const newName = uuidv4();

        const renamedFile = new File([item.file], newName, {
          type: item.file.type,
        });

        formData.append("image", renamedFile);
        data.push({
          isExisting: false,
          position: item.index,
          name: newName,
        });
      } else {
        data.push({
          isExisting: true,
          position: item.index,
          url: item.url,
        });
      }
    });
    formData.append("data", JSON.stringify(data));

    await patch({
      path: `/properties/carousel/${slug}`,
      data: formData,
      token: auth.accessToken,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dataPropertiesSlugQuery.refetch();
  };

  if (!dataPropertiesSlugQuery.data)
    return <AppLayout>{/*  <LayoutContainer></LayoutContainer> */}</AppLayout>;

  return (
    <AppLayout>
      <LayoutContainer>
        <Stack
          direction="row"
          alignItems={{ xs: "flex-end", md: "center" }}
          justifyContent="space-between"
          pb={{ xs: "40px", md: "70px" }}
          pt={{ xs: "80px", md: "120px" }}
        >
          <Stack direction={{ xs: "column" }}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              alignItems={{ xs: "start", md: "center" }}
              gap={2}
            >
              <Typography
                variant="h5"
                color="text.secondary"
                textTransform={"capitalize"}
                fontWeight={"bold"}
              >
                {dataPropertiesSlugQuery.data?.name || ""}
              </Typography>
              <StyledLocationBox>
                <Iconify icon="carbon:location" />
                <Typography variant="body1" color="text.secondary"></Typography>
              </StyledLocationBox>
            </Stack>
            <Box>
              {/*  <Typography
                variant="h6"
                color="text.secondary"
                textTransform={"capitalize"}
                fontSize={"0.9rem"}
              >
                {dataPropertiesSlugQuery.data?.city ||
                  "Tlaquepaque, Jalisco. MX"}
              </Typography> */}
              <PropertyLocalEdit slug={slug} />
            </Box>
          </Stack>
        </Stack>

        <UploadHauseCarousel
          initialImages={dataPropertiesSlugQuery.data.carrouselImagesUrl}
          /*   onImagesChange={(images) => console.log("Images changed:", images)} */
          onUpload={uploadCarousel}
        />
        <Grid container spacing={2} pb={{ xs: 3, md: 8 }}>
          <Grid item xs={12} md={6}>
            <PropertyDescriptionEdit slug={slug} />
          </Grid>

          <Grid item xs={12} md={6}>
            <PropertyDescriptionListEdit slug={slug} />
          </Grid>
        </Grid>
        <ModelsCarouselEdit
          initialModels={
            dataPropertiesSlugQuery.data?.carrouselModelImagesUrl || []
          }
          onUpload={async (images) => {
            const data = [];
            const formData = new FormData();
            for (let a = 0; a < images.length; a++) {
              const image = images[a];

              let newData = {
                ...image,
                index: a,
                images: [],
                isNew: true,
              };
              for (let index = 0; index < image.images.length; index++) {
                const element = image.images[index];
                if (element.isFromServer) {
                  newData.images.push(element.url);
                  newData.isNew = false;
                  continue;
                }

                const newName = uuidv4();

                const renamedFile = new File([element.file], newName, {
                  type: element.file.type,
                });
                formData.append("image", renamedFile);

                newData.images.push(newName);
              }

              data.push(newData);
            }

            formData.append("data", JSON.stringify(data));

            await patch({
              path: `/properties/carousel-models/${slug}`,
              data: formData,
              token: auth.accessToken,
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            dataPropertiesSlugQuery.refetch();
          }}
        />
      </LayoutContainer>
    </AppLayout>
  );
};

export default PropertiesViewEdit;
